import axios from 'axios';
import {setupCache} from 'axios-cache-adapter';
import urlJoin from 'url-join';
import utilities from '../utilities/dc.utility';

/**
 * *********************************
 * default values
 * *********************************
 */
const defaultInclude = 'details.image,details.tour.stages,details.tour.poi.image';
const defaultIncludeDetail = 'details.image,details.tour.stages,details.tour.poi.image';
const defaultFields = '';//'name,geo.longitude,geo.latitude,location.geo.longitude,location.geo.latitude,contentLocation.geo.longitude,contentLocation.geo.latitude';
const defaultFieldsDetail = '';
/**
 * ********************************
 * ********************************
 */

const cache = setupCache({
    maxAge: 15 * 60 * 1000
});
const $http = axios.create({
    adapter: cache.adapter
});

class DataService {

    constructor(ApiHost, ApiEndpoint, locale) {
        this._apiHost = ApiHost;
        this._apiEndpoint = ApiEndpoint;
        this._page = 1;
        this._data = [];
        this._meta = {};
        this._locale = locale || 'de';
    }

    _createEndpoint(endpoint) {
        endpoint = endpoint || this._apiEndpoint;
        return urlJoin(this._apiHost, 'endpoints', endpoint);
    }

    _loadAllRecursively(apiParams, endpoint, resolve, reject) {
        apiParams['page'] = this._page;
        apiParams['language'] = this._locale;
        this._load(apiParams, endpoint).then(response => {
            this._page++;

            response.data['@graph'] = response.data['@graph'] || [];

            if (response.data['@graph'].length) {
                this._data.push(...response.data['@graph']);
                this._meta = response.data.meta;
            }
            if (this._page <= this._meta.pages) {
                this._loadAllRecursively(apiParams, endpoint, resolve, reject);
            } else {
                resolve({
                    data: this._data,
                    meta: this._meta
                });
            }
        }).catch(error => {

        });
    }

    _load(apiParams, endpoint) {
        let searchUrl = utilities.searchUrl(
            this._apiHost,
            endpoint || this._apiEndpoint,
            apiParams.page || 1,
            apiParams.pageSize || 100,
            apiParams.include || [],
            apiParams.fields || [],
            apiParams.categories || [],
            apiParams.query || "",
            apiParams.locale || this._locale
        );

        return new Promise((resolve, reject) => {
            $http
                .get(searchUrl)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                });
        });
    }

    load(apiParams, endpoint) {

        let defaultParams = {
            include: defaultInclude,
            fields: defaultFields,
            page: {number: 1},
            language: this._locale
        };
        apiParams = apiParams || {};
        apiParams = _.merge({}, defaultParams, apiParams);

        return new Promise((resolve, reject) => {
            this._load(apiParams, endpoint).then(response => {
                console.log(response.data);
                response.data['@graph'] = response.data['@graph'] || [];
                resolve({
                    data: response.data['@graph'],
                    meta: response.data.meta
                });
            })
            .catch(error => {
                reject(error);
            });
        });
    }

    loadAll(apiParams, endpoint) {
        let defaultParams = {
            include: defaultInclude,
            fields: defaultFields,
            page: {number: 1},
            language: this._locale
        };
        apiParams = apiParams || {};
        apiParams = _.merge({}, defaultParams, apiParams);

        return new Promise((resolve, reject) => {
            this._loadAllRecursively(
                apiParams,
                endpoint,
                resolve,
                reject
            );
        });
    }

    async loadSingle(id, include, fields) {

        include = include || defaultIncludeDetail;
        fields = fields || defaultFieldsDetail;//'thumbnailUrl,cc:attributionName,image.thumbnailUrl,image.cc:attributionName,photo.thumbnailUrl,photo.cc:attributionName';

        let url = urlJoin(this._apiHost, 'things', id);
        let params = {
            include: include,
            language: this._locale
        };
        if (!!fields) {
            params.fields = fields;
        }
        return $http
            .get(url, {
                params: params
            })
            .then(response => {
                if (response.data) {
                    return _.get(response, 'data.@graph[0]');
                }
            })
            .catch(e => {
                console.log(e);
            });
    }

    async loadCategoryTree(id) {
        let url = urlJoin(this._apiHost, 'concept_schemes', id, 'concepts');

        return new Promise((resolve, reject) => {
            $http
                .get(url,{
                    params: {'language':this._locale}
                }).then(response => {
                let result = [];
                _.get(response, 'data.@graph', []).map(item => {
                    result.push({
                        id: _.get(item, '@id', ''),
                        name: _.get(item, 'skos:prefLabel', '')
                    });
                });
                resolve(result);
            });
        });
    }
}

let defaultService = null;
/**
 * we are exporting the class and a default service.
 * This way we can create a separate instance if needed
 * and it makes testing easier
 */
export {DataService};
export const initializeDefault = (ApiHost, ApiEndpoint, locale) => {
    defaultService = defaultService || new DataService(ApiHost, ApiEndpoint, locale);
    return defaultService;
};
export {defaultService as instance};